import InputType from "@/services/Input/InputType.js";
import Catalog from "../StockClosingCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " + Catalog.ClosingNumber.Label,
    Type: InputType.Text,
    MaxLength: 50
  },
  Date: {
    Label: Catalog.Date.Label,
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  }
}